export default __webpack_public_path__ + "static/media/logo_etmday.d37f896d.png";